import raw from "./note.svg?raw";
import { stripIconSvg } from "./stripIconSvg";

/** Notes tool glyph (#157) — a card with a leader line running to a dot.
 *
 *  Shares its source with the toolbar button's `<!-- svg:src/icons/note.svg -->`
 *  marker, normalised through {@link stripIconSvg} so the runtime constant and
 *  the build-time inline can't drift apart in paint or size. */
export const noteIcon = stripIconSvg(raw);
